var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFailed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM9.53477 7.59023C8.9978 7.05326 8.1272 7.05326 7.59023 7.59023C7.05326 8.1272 7.05326 8.9978 7.59023 9.53477L10.0555 12L7.59023 14.4652C7.05326 15.0022 7.05326 15.8728 7.59023 16.4098C8.1272 16.9467 8.9978 16.9467 9.53477 16.4098L12 13.9445L14.4652 16.4098C15.0022 16.9467 15.8728 16.9467 16.4098 16.4098C16.9467 15.8728 16.9467 15.0022 16.4098 14.4652L13.9445 12L16.4098 9.53477C16.9467 8.9978 16.9467 8.1272 16.4098 7.59023C15.8728 7.05326 15.0022 7.05326 14.4652 7.59023L12 10.0555L9.53477 7.59023Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFailed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Failed.b4d65d1e479935c7a6117e9460330996.svg";